/* eslint-disable import/order */
import { issueTypesResource } from '@jira/admin-pages__issue-types-resources/src/issueTypesResource.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssueTypesRoute } from '@jira/router-routes__admin-pages-issue-types-routes/src/globalSettingsIssueTypesRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import IssueTypesDirectory, {
	LazyIssueTypesDirectory,
} from './ui/spa/admin-pages/issue-types/issue-types-directory/index.tsx';

export const globalSettingsIssueTypesRouteEntry: Route = createEntry(
	globalSettingsIssueTypesRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.issue-types',
		// eslint-disable-next-line no-restricted-syntax
		component: IssueTypesDirectory,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			issueTypesResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyIssueTypesDirectory],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
